// Mirrors the app's ExploreTimelineScreen discovery buckets and signal weights.
const order = ['reviews', 'popular', 'playlists'];
export function timelineScore(item, reason) {
  if (reason === 'reviews') return (item.album.reviewCount || 0) * 60;
  if (reason === 'playlists') return (item.playlistCount || 0) * 40;
  return (item.viewCount || 0) + (item.album.bookmarkCount || 0) * 25;
}
export function timelineReason(item) {
  const [reviews, popular, playlists] = order.map((reason) => timelineScore(item, reason));
  return reviews >= popular && reviews >= playlists
    ? 'reviews'
    : playlists >= popular
      ? 'playlists'
      : 'popular';
}
export function mixTimelineItems(items, limit = 12, random = Math.random) {
  const indices = new Map(items.map((item, index) => [item.album.id, index]));
  const buckets = new Map(
    order.map((reason) => [
      reason,
      items
        .filter((item) => timelineScore(item, reason) > 0)
        .sort(
          (a, b) =>
            timelineScore(b, reason) - timelineScore(a, reason) ||
            indices.get(a.album.id) - indices.get(b.album.id),
        ),
    ]),
  );
  const selected = [],
    seen = new Set();
  while (selected.length < limit) {
    let added = false;
    for (const reason of order) {
      const bucket = buckets.get(reason);
      let item = bucket.shift();
      while (item && seen.has(item.album.id)) item = bucket.shift();
      if (!item) continue;
      selected.push({ item, reason });
      seen.add(item.album.id);
      added = true;
      if (selected.length === limit) break;
    }
    if (!added) break;
  }
  for (const item of items) {
    if (selected.length === limit) break;
    if (seen.has(item.album.id)) continue;
    selected.push({ item, reason: timelineReason(item) });
    seen.add(item.album.id);
  }
  for (let index = selected.length - 1; index > 0; index -= 1) {
    const swap = Math.floor(random() * (index + 1));
    [selected[index], selected[swap]] = [selected[swap], selected[index]];
  }
  return selected;
}
export function timelineReasonLabel(item, reason, locale) {
  if (reason === 'reviews')
    return locale === 'ko'
      ? `리뷰 ${item.album.reviewCount || 0}개`
      : `${item.album.reviewCount || 0} reviews`;
  if (reason === 'playlists')
    return locale === 'ko'
      ? `플리 ${item.playlistCount || 0}개`
      : `${item.playlistCount || 0} playlists`;
  return locale === 'ko' ? '많이 찾음' : 'Popular on Postpop';
}
export function timelineContext(item, locale) {
  if (item.source === 'APPLE_MUSIC_EDITORIAL')
    return locale === 'ko' ? 'Apple Music 대표 앨범' : 'Apple Music Essential Album';
  if (item.album.reviewCount > 0) return timelineReasonLabel(item, 'reviews', locale);
  if (item.playlistCount > 0) return timelineReasonLabel(item, 'playlists', locale);
  if (item.album.bookmarkCount > 0)
    return locale === 'ko'
      ? `${item.album.bookmarkCount}명이 저장`
      : `Saved by ${item.album.bookmarkCount} people`;
  if (item.viewCount > 0)
    return locale === 'ko' ? '포스트팝에서 다시 찾는 중' : 'Being rediscovered on Postpop';
  return locale === 'ko' ? '첫 기록을 기다려요' : 'Awaiting its first record';
}
